import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import brand from '../../Images/brand-logo-name.svg';
import phoneimage from '../../Images/phoneimage.svg';
import './Navbar.css';

const HOME_SECTION_IDS = ['home', 'products', 'aboutus', 'happycustomer', 'faqs', 'footer'];
const SCROLL_OFFSET = 150;
const SECTION_SCROLL_OFFSETS = {
    home: -80,
    products: -80,
    aboutus: -80,
    happycustomer: -80,
    faqs: -80,
    footer: -80
};

const Navbar = ({ isProgrammaticScroll, setIsProgrammaticScroll }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState('home');
    const scrollTimeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (isProgrammaticScroll || location.pathname !== '/') return;
            const getStartedSection = document.getElementById('getstarted');
            if (getStartedSection && getStartedSection.getBoundingClientRect().top <= SCROLL_OFFSET) {
                setActiveSection('');
                return;
            }
            let foundSection = '';
            for (const id of [...HOME_SECTION_IDS].reverse()) {
                const section = document.getElementById(id);
                if (section && section.getBoundingClientRect().top <= SCROLL_OFFSET) {
                    foundSection = id;
                    break;
                }
            }
            if (window.scrollY < SCROLL_OFFSET) {
                foundSection = 'home';
            }
            if (foundSection) {
                setActiveSection(foundSection);
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [location.pathname, isProgrammaticScroll]);

    useEffect(() => {
        clearTimeout(scrollTimeoutRef.current);
        const target = location.state?.targetSection;
        if (target) {
            setActiveSection(target);
            setIsProgrammaticScroll(true);
            setTimeout(() => {
                scrollToSection(target);
                setTimeout(() => setIsProgrammaticScroll(false), 1000);
            }, 0);
            window.history.replaceState({}, document.title);
        } else if (location.pathname === '/products') {
            setActiveSection('products');
            window.scrollTo(0, 0);
        } else if (location.pathname === '/') {
            if (window.scrollY < SCROLL_OFFSET) setActiveSection('home');
        } else {
            setActiveSection('');
        }
    }, [location, setIsProgrammaticScroll]);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            const yOffset = SECTION_SCROLL_OFFSETS[sectionId] || -80;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const handleNavigation = (e, sectionId) => {
        e.preventDefault();

        if (sectionId === 'products') {
            navigate('/products');
        } else {
            if (location.pathname !== '/') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    navigate('/', { state: { targetSection: sectionId } });
                }, 200); 
            } else {
                setIsProgrammaticScroll(true);
                setActiveSection(sectionId);
                scrollToSection(sectionId);
                scrollTimeoutRef.current = setTimeout(() => setIsProgrammaticScroll(false), 1000);
            }
        }
    };
    
    return (
        <nav className='navbar fixed-top navbar-expand-lg navbar-dark bg-dark px-4'>
            <div className='container-fluid'>
                <div
                    className='navbar-brand d-flex align-items-center'
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => handleNavigation(e, 'home')}>
                    <img src={brand} alt="Logo" className="brand-name-logo" />
                </div>
                <button className='navbar-toggler' type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                    <span className='navbar-toggler-icon'></span>
                </button>
                <div className='collapse navbar-collapse' id="navbarNav">
                    <ul className='navbar-nav'>
                        <li className='nav-item'><a className={`nav-link ${activeSection === 'home' ? 'active-link' : ''}`} href="#home" onClick={(e) => handleNavigation(e, 'home')}>Home</a></li>
                        <li className='nav-item'><a className={`nav-link ${activeSection === 'products' ? 'active-link' : ''}`} href="/products" onClick={(e) => handleNavigation(e, 'products')}>Products</a></li>
                        <li className='nav-item'><a className={`nav-link ${activeSection === 'aboutus' ? 'active-link' : ''}`} href="#aboutus" onClick={(e) => handleNavigation(e, 'aboutus')}>About Us</a></li>
                        <li className='nav-item'><a className={`nav-link ${activeSection === 'happycustomer' ? 'active-link' : ''}`} href='#happycustomer' onClick={(e) => handleNavigation(e, 'happycustomer')}>Testimonial</a></li>
                        <li className='nav-item'><a className={`nav-link ${activeSection === 'faqs' ? 'active-link' : ''}`} href="#faqs" onClick={(e) => handleNavigation(e, 'faqs')}>FAQs</a></li>
                    </ul>
                    <div className='contact-btn-container'>
                        <a className={`contact-nav-link ${activeSection === 'footer' ? 'active-link' : ''}`} href='#footer' onClick={(e) => handleNavigation(e, 'footer')}>
                            <button className='contact-button'>
                                <img src={phoneimage} alt='phone' className='phone-image' /> Contact
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;